const assets = [];
function registerAsset(asset) {
  return assets.push(asset);
}
function getAssetByID(assetId) {
  return assets[assetId - 1];
}
export {
  getAssetByID,
  registerAsset
};
//# sourceMappingURL=index.js.map
